export default __webpack_public_path__ + "static/media/banner.998c2317.jpg";